module.exports = __webpack_public_path__ + "img/16d004-16.b3934ce7.jpg";